import { LDUser } from 'launchdarkly-js-client-sdk'
import { identify } from '@sennder/senn-node-feature-flags-frontend'
import { LAUNCH_DARKLY_STATIC_KEY } from '@/common/config'

export const identifyUserInLaunchDarkly = async (user: any) => {
  const ldUser: LDUser = {
    key: user.uuid,
    email: user.username,
    // TODO: pass additional user fields
    // firstName: user.firstName,
    // lastName: user.lastName,
    // country: user.timezone,
  }
  await identify(ldUser)
  console.info(
    '[driver-web-app - LaunchDarkly]: User is identified in LaunchDarkly'
  )
}

export const getLaunchDarklyAnonymousUser = (): LDUser => ({
  key: LAUNCH_DARKLY_STATIC_KEY,
})

export const anonymizeUserInLaunchDarkly = async () => {
  await identify(await getLaunchDarklyAnonymousUser())
  console.info(
    '[driver-web-app - LaunchDarkly]: User is anonymized in LaunchDarkly'
  )
}
